import React, { useContext } from "react";
import { NotFoundResult } from "components/atoms/outputs";

const Page404 = () => {
  return <NotFoundResult />;
  // return <h1>{translate("pages").notfound.title}</h1>;
};

export default Page404;
